import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'

import {
  UI_COLOR_DANGER_BORDER,
  UI_COLOR_DANGER_SOFT,
  UI_COLOR_DANGER_TEXT,
  UI_COLOR_SUCCESS_EMPHASIS,
  UI_COLOR_SUCCESS_EMPHASIS_BG,
  UI_COLOR_SUCCESS_EMPHASIS_TEXT
} from '../../../constants/uiColors'

export const FEEDBACK_ALERT_DURATION_MS = 5000

export const FEEDBACK_ALERT_STYLES = {
  error: {
    border: UI_COLOR_DANGER_BORDER,
    borderWidth: 1,
    background: UI_COLOR_DANGER_SOFT,
    text: UI_COLOR_DANGER_TEXT,
    icon: UI_COLOR_DANGER_TEXT,
    fontWeight: 600
  },
  warning: {
    border: '#FFA45B',
    borderWidth: 1,
    background: '#FFF3E6',
    text: '#6F3D09',
    icon: '#F57C00',
    fontWeight: 600
  },
  success: {
    border: UI_COLOR_SUCCESS_EMPHASIS,
    borderWidth: 1,
    background: UI_COLOR_SUCCESS_EMPHASIS_BG,
    text: UI_COLOR_SUCCESS_EMPHASIS_TEXT,
    icon: UI_COLOR_SUCCESS_EMPHASIS,
    fontWeight: 500
  }
}

export const FEEDBACK_ALERT_ICONS = {
  error: <ErrorOutlineIcon fontSize="inherit" />,
  warning: <WarningAmberOutlinedIcon fontSize="inherit" />,
  success: <CheckCircleOutlineIcon fontSize="inherit" />
}
